import '../styles/generic.css';

import AppStoreDownloadIcon from '../assets/icons/app-store-download-white.svg';
import GooglePlayDownloadIcon from '../assets/icons/google-play-download-white.svg';

interface NativeStoreLinksProps {
  /**
   * App Store link
   */
  appStoreLink: string;
  /**
   * Google Play link
   */
  googlePlayLink: string;
  /**
   * App Store icon
   */
  appStoreIcon?: string;
  /**
   * Google Play icon
   */
  googlePlayIcon?: string;
}

export const NativeStoreLinks = ({
  appStoreLink,
  googlePlayLink,
  appStoreIcon,
  googlePlayIcon,
}: NativeStoreLinksProps) => (
  <div className="native-app-store-buttons">
    <a
      href={appStoreLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src={appStoreIcon ?? AppStoreDownloadIcon}
        alt="App Store Download"
      />
    </a>
    <a
      href={googlePlayLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src={googlePlayIcon ?? GooglePlayDownloadIcon}
        alt="Google Play Download"
      />
    </a>
  </div>
);
